<script>
  import { modal } from 'vue-strap';
  import moment from 'moment';
  import liberarPagamento from '../servico';
  import { iconeStatus } from '../status';

  const SITUACAO_PENDENTE = 1;
  const SITUACAO_LIBERADO = 2;
  const SITUACAO_REPROVADO = 3;

  export default {
    components: { modal },
    props: {
      mostrar: {
        type: Boolean,
        required: true,
      },
      id: {
        default: null,
      },
      podeLiberar: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        detalhe: null,
        carregando: false,
        salvando: false,
        modo: 'ver',
        selecionados: [],
        observacao: '',
      }
    },
    methods: {
      carregar() {
        if (!this.id) return;

        this.carregando = true;
        this.detalhe = null;
        this.modo = 'ver';
        this.observacao = '';

        return liberarPagamento
          .detalhe(this.id)
          .then(detalhe => {
            this.detalhe = detalhe;
            this.selecionados = (detalhe.rateios || [])
              .filter(rateio => rateio.selecionavel)
              .map(rateio => rateio.idLancRateioCrypt);
            this.carregando = false;
          })
          .catch(erro => {
            this.carregando = false;
            this.$mensagemErro(erro, 'Erro ao carregar os dados do lançamento.');
          });
      },
      limpar() {
        this.detalhe = null;
        this.carregando = false;
        this.salvando = false;
        this.modo = 'ver';
        this.selecionados = [];
        this.observacao = '';
      },
      iconeStatus,
      classeLinha(rateio) {
        return {
          'rateio-destacado': rateio.destacado,
          'rateio-agrupado': rateio.agrupado,
          'rateio-sem-acesso': rateio.semAcesso,
        };
      },
      irPara(modo) {
        this.modo = modo;
      },
      sair() {
        this.$refs.modal.action(false, 3);
      },
      confirmar() {
        const liberando = this.modo === 'liberando';
        const promessa = liberando
          ? liberarPagamento.liberar(this.detalhe.idLancRateioCrypt, this.selecionados)
          : liberarPagamento.reprovar(this.detalhe.idLancRateioCrypt, this.selecionados, this.observacao);

        this.salvando = true;

        return promessa
          .then(() => {
            this.salvando = false;
            toastr.success(liberando ? 'Pagamento liberado com sucesso.' : 'Pagamento reprovado.');
            this.$emit('decidido');
            this.sair();
          })
          .catch(erro => {
            this.salvando = false;
            this.$mensagemErro(erro, liberando ? 'Erro ao tentar liberar o pagamento.' : 'Erro ao tentar reprovar o pagamento.');
          });
      },
      formatarDataHora(data) {
        return data ? moment(String(data)).format('DD/MM/YYYY [às] HH:mm') : '';
      },
      formatarMoeda(valor) {
        return (valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
    },
    computed: {
      show() {
        return this.mostrar;
      },
      rateiosSelecionaveis() {
        if (!this.detalhe || !this.detalhe.rateios) return [];

        return this.detalhe.rateios.filter(rateio => rateio.selecionavel);
      },
      mostrarSelecao() {
        return this.podeLiberar && this.modo === 'ver' && this.rateiosSelecionaveis.length > 1;
      },
      rateiosEscolhidos() {
        return this.rateiosSelecionaveis.filter(rateio => this.selecionados.includes(rateio.idLancRateioCrypt));
      },
      quantidadeLiberar() {
        return this.rateiosEscolhidos.length;
      },
      quantidadeReprovar() {
        return this.rateiosEscolhidos.filter(rateio => rateio.situacao === SITUACAO_PENDENTE).length;
      },
      valorEscolhido() {
        return this.rateiosEscolhidos.reduce((soma, rateio) => soma + (rateio.valor || 0), 0);
      },
      mostrarBotaoLiberar() {
        return this.podeLiberar && this.detalhe && this.detalhe.podeLiberar;
      },
      mostrarBotaoReprovar() {
        return this.podeLiberar && this.detalhe && this.detalhe.podeReprovar;
      },
      textoBotaoLiberar() {
        if (this.quantidadeLiberar > 1) return `Liberar ${this.quantidadeLiberar} rateios`;

        return 'Liberar';
      },
      textoBotaoReprovar() {
        if (this.quantidadeReprovar > 1) return `Reprovar ${this.quantidadeReprovar} rateios`;

        return 'Reprovar';
      },
      textoAvisoReprovar() {
        const inicio = this.quantidadeReprovar > 1
          ? `Os ${this.quantidadeReprovar} rateios ficam bloqueados`
          : 'O rateio fica bloqueado';

        return `${inicio} para o borderô. Você pode liberar depois, se mudar de ideia.`;
      },
      textoConfirmacaoLiberar() {
        const valor = this.formatarMoeda(this.valorEscolhido);

        if (this.quantidadeLiberar > 1) {
          return `Você está liberando ${this.quantidadeLiberar} rateios deste lançamento, somando R$ ${valor}. Depois de liberados, a fundação poderá incluí-los no borderô.`;
        }

        return `Deseja liberar o pagamento deste rateio de R$ ${valor}? Depois de liberado, a fundação poderá incluí-lo no borderô.`;
      },
      faixa() {
        const detalhe = this.detalhe;

        if (!detalhe) return null;

        const responsavel = detalhe.nomeResponsavelDecisao ? ` por ${detalhe.nomeResponsavelDecisao}` : '';
        const quando = detalhe.dataDecisao ? ` em ${this.formatarDataHora(detalhe.dataDecisao)}` : '';

        if (detalhe.pago) {
          return { classe: 'faixa-pago', icone: 'fa-check-circle', titulo: 'Pagamento efetuado.', texto: '' };
        }

        if (detalhe.situacao === SITUACAO_REPROVADO) {
          return {
            classe: 'faixa-reprovado',
            icone: 'fa-ban',
            titulo: `Reprovado${responsavel}${quando}.`,
            texto: 'O pagamento continua bloqueado para o borderô.',
            observacao: detalhe.observacaoDecisao,
          };
        }

        if (detalhe.situacao === SITUACAO_LIBERADO) {
          return {
            classe: 'faixa-liberado',
            icone: 'fa-check-circle',
            titulo: `Liberado${responsavel}${quando}.`,
            texto: 'Aguardando pagamento pela fundação.',
          };
        }

        if (detalhe.usaDataPrevisao && !detalhe.dataPrevisao) {
          return {
            classe: 'faixa-aguardando',
            icone: 'fa-clock-o',
            titulo: 'Aguardando a fundação programar o pagamento.',
            texto: 'A liberação fica disponível quando o lançamento tiver data de previsão.',
          };
        }

        const vencido = detalhe.dataReferencia && moment(String(detalhe.dataReferencia)).isBefore(moment().startOf('day'));

        return {
          classe: vencido ? 'faixa-vencido' : 'faixa-aguardando',
          icone: vencido ? 'fa-exclamation-circle' : 'fa-clock-o',
          titulo: 'Aguardando sua decisão.',
          texto: vencido ? 'O vencimento já passou.' : '',
        };
      },
    }
  }
</script>

<template>
  <div>
    <modal ref="modal"
           class="modal-centralizado"
           :value="show"
           effect="fade"
           :large="true"
           :backdrop="false"
           @opened="carregar"
           @closed="limpar(), $emit('fechado')">
      <div slot="modal-header" class="modal-header">Dados do lançamento</div>

      <div v-if="carregando" class="text-center">
        <i class="fa fa-spinner fa-pulse"></i> Carregando...
      </div>

      <div v-if="detalhe && !carregando">
        <div v-if="faixa" :class="['faixa-situacao', faixa.classe]">
          <div>
            <i :class="['fa', faixa.icone]"></i>
            <strong>{{ faixa.titulo }}</strong>
            {{ faixa.texto }}
          </div>
          <div v-if="faixa.observacao" class="faixa-observacao">Observação: {{ faixa.observacao }}</div>
        </div>

        <div class="row">
          <div class="col-xs-3">
            <label class="control-label block">Lançamento</label>
            <p class="form-control-static">{{ detalhe.idLancamento }}</p>
          </div>
          <div :class="detalhe.usaDataPrevisao ? 'col-xs-2' : 'col-xs-3'">
            <label class="control-label block">Emissão</label>
            <p class="form-control-static">{{ detalhe.dataEmissao | formatarData('---') }}</p>
          </div>
          <div :class="detalhe.usaDataPrevisao ? 'col-xs-2' : 'col-xs-3'">
            <label class="control-label block">Vencimento</label>
            <p class="form-control-static">{{ detalhe.dataVencimento | formatarData('---') }}</p>
          </div>
          <div class="col-xs-2" v-if="detalhe.usaDataPrevisao">
            <label class="control-label block">Previsão</label>
            <p class="form-control-static">{{ detalhe.dataPrevisao | formatarData('---') }}</p>
          </div>
          <div class="col-xs-3">
            <label class="control-label block">Pagamento</label>
            <p class="form-control-static">{{ detalhe.dataPagamento | formatarData('---') }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-6">
            <label class="control-label block">Beneficiário</label>
            <p class="form-control-static">{{ detalhe.beneficiario || '---' }}</p>
          </div>
          <div class="col-xs-3">
            <label class="control-label block">CPF / CNPJ</label>
            <p class="form-control-static">{{ detalhe.cpfCnpj || '---' }}</p>
          </div>
          <div class="col-xs-3">
            <label class="control-label block">Conta</label>
            <p class="form-control-static">{{ detalhe.nomeConta || '---' }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-6">
            <label class="control-label block">Histórico</label>
            <p class="form-control-static">{{ detalhe.historico || '---' }}</p>
          </div>
          <div class="col-xs-6">
            <label class="control-label block">Complemento</label>
            <p class="form-control-static">{{ detalhe.complemento || '---' }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-3">
            <label class="control-label block">Documento</label>
            <p class="form-control-static">{{ detalhe.documento || '---' }}</p>
          </div>
          <div class="col-xs-3">
            <label class="control-label block">Documento receber/pagar</label>
            <p class="form-control-static">{{ detalhe.documentoReceberPagar || '---' }}</p>
          </div>
          <div class="col-xs-3">
            <label class="control-label block">Nota fiscal</label>
            <p class="form-control-static">{{ detalhe.documentoNotaFiscal || '---' }}</p>
          </div>
          <div class="col-xs-3">
            <label class="control-label block">Valor do lançamento</label>
            <p class="form-control-static">{{ detalhe.valorLancamento | formatarNumero }}</p>
          </div>
        </div>

        <p v-if="mostrarSelecao" class="ajuda-selecao">
          Este lançamento tem mais de um rateio seu. Desmarque os que não quer liberar ou reprovar agora.
        </p>

        <div class="table-responsive m-t-sm">
          <table class="table table-bordered tabela-rateios">
            <thead>
              <tr>
                <th v-if="mostrarSelecao" class="coluna-selecao"></th>
                <th>Projeto</th>
                <th>Rubrica</th>
                <th>Subrubrica</th>
                <th class="text-right">Valor</th>
                <th>Situação</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(rateio, index) in detalhe.rateios" :key="index" :class="classeLinha(rateio)">
                <td v-if="mostrarSelecao" class="coluna-selecao">
                  <input v-if="rateio.selecionavel"
                         :id="'rateio-' + index"
                         type="checkbox"
                         :value="rateio.idLancRateioCrypt"
                         v-model="selecionados"
                         :aria-label="'Selecionar rateio de ' + rateio.nomeRubrica">
                </td>
                <td>{{ rateio.nomeProjeto || '---' }}</td>
                <td>{{ rateio.nomeRubrica || '---' }}</td>
                <td>{{ rateio.nomeSubrubrica || '---' }}</td>
                <td class="text-right">{{ rateio.valor | formatarNumero }}</td>
                <td :class="{ 'text-danger': rateio.statusCodigo === 2, 'texto-reprovado': rateio.statusCodigo === 5 }">
                  <i v-if="rateio.statusCodigo" :class="['status-icone', iconeStatus(rateio.statusCodigo)]"></i>
                  {{ rateio.descricaoSituacao || '---' }}
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th :colspan="mostrarSelecao ? 4 : 3">Total dos rateios</th>
                <th class="text-right">{{ detalhe.totalRateios | formatarNumero }}</th>
                <th></th>
              </tr>
            </tfoot>
          </table>
        </div>

        <div v-if="modo === 'liberando'" class="caixa-confirmacao caixa-liberar">
          <i class="fa fa-question-circle"></i>
          {{ textoConfirmacaoLiberar }}
        </div>

        <div v-if="modo === 'reprovando'" class="caixa-confirmacao caixa-reprovar">
          <label class="control-label block" for="observacao-reprovacao">Observação (opcional)</label>
          <textarea id="observacao-reprovacao"
                    class="form-control"
                    rows="3"
                    maxlength="500"
                    placeholder="Se quiser, explique ao financeiro o motivo da reprovação"
                    v-model="observacao"></textarea>
          <small>{{ textoAvisoReprovar }}</small>
        </div>
      </div>

      <div v-if="!detalhe && !carregando" class="text-center">
        Nenhum dado encontrado para este lançamento.
      </div>

      <div slot="modal-footer" class="modal-footer">
        <template v-if="modo === 'ver'">
          <button type="button"
                  class="btn btn-reprovar"
                  v-if="mostrarBotaoReprovar"
                  :disabled="quantidadeReprovar === 0"
                  @click="irPara('reprovando')">
            <i class="fa fa-ban"></i> {{ textoBotaoReprovar }}
          </button>
          <button type="button"
                  class="btn btn-primary"
                  v-if="mostrarBotaoLiberar"
                  :disabled="quantidadeLiberar === 0"
                  @click="irPara('liberando')">
            <i class="fa fa-check"></i> {{ textoBotaoLiberar }}
          </button>
          <button type="button" class="btn btn-sair" @click="sair">
            <i class="fa fa-sign-out"></i> Sair
          </button>
        </template>

        <template v-else>
          <button type="button"
                  :class="['btn', modo === 'liberando' ? 'btn-primary' : 'btn-reprovar-confirmar']"
                  :disabled="salvando"
                  @click="confirmar">
            <i :class="['fa', salvando ? 'fa-spinner fa-pulse' : (modo === 'liberando' ? 'fa-check' : 'fa-ban')]"></i>
            {{ modo === 'liberando' ? 'Confirmar liberação' : 'Confirmar reprovação' }}
          </button>
          <button type="button" class="btn btn-default" :disabled="salvando" @click="irPara('ver')">
            <i class="fa fa-reply"></i> Voltar
          </button>
        </template>
      </div>
    </modal>
  </div>
</template>

<style scoped>
  .faixa-situacao {
    border-left: 5px solid;
    border-radius: 4px;
    padding: 10px 14px;
    margin-bottom: 15px;
  }

  .faixa-situacao .fa {
    margin-right: 4px;
  }

  .faixa-observacao {
    margin-top: 4px;
  }

  .faixa-vencido {
    background-color: #fdecea;
    border-left-color: #d9534f;
    color: #6b1f1c;
  }

  .faixa-aguardando {
    background-color: #fcf8e3;
    border-left-color: #f0ad4e;
    color: #6a4c12;
  }

  .faixa-reprovado {
    background-color: #f4f1f8;
    border-left-color: #8e6bb8;
    color: #4a2f6a;
  }

  .faixa-liberado {
    background-color: #e8f1f8;
    border-left-color: #1c84c6;
    color: #164a6e;
  }

  .faixa-pago {
    background-color: #dff0d8;
    border-left-color: #5cb85c;
    color: #2b542c;
  }

  .ajuda-selecao {
    margin: 4px 0 6px;
    color: #5d6062;
  }

  .coluna-selecao {
    width: 34px;
    text-align: center;
  }

  .rateio-destacado td {
    font-weight: 600;
    background-color: #f5fcfa;
  }

  .tabela-rateios tbody tr.rateio-destacado td {
    border-top-color: #8fd9c8;
    border-bottom-color: #8fd9c8;
  }

  .status-icone {
    font-size: 1.35em;
    vertical-align: middle;
  }

  .status-aguardando {
    color: #f8ac59;
  }

  .status-vencido {
    color: #ed5565;
  }

  .status-liberado {
    color: #1c84c6;
  }

  .status-pago {
    color: #1d9d74;
  }

  .status-reprovado {
    color: #8e6bb8;
  }

  .texto-reprovado {
    color: #5a3d7a;
  }

  .rateio-agrupado td {
    font-style: italic;
  }

  .rateio-sem-acesso td {
    color: #8a8a8a;
  }

  .form-control-static {
    margin-bottom: 10px;
    word-break: break-word;
  }

  .caixa-confirmacao {
    border-radius: 4px;
    padding: 12px 14px;
    margin-top: 10px;
  }

  .caixa-liberar {
    background-color: #eaf6f2;
    border: 1px solid #b9e2d6;
    color: #145a4a;
    font-size: 14px;
  }

  .caixa-reprovar {
    background-color: #f7f4fa;
    border: 1px solid #d9cce8;
    color: #4a2f6a;
  }

  .caixa-reprovar small {
    display: block;
    margin-top: 6px;
    color: #5d6062;
  }

  .modal-footer .btn {
    height: 34px;
  }

  .btn-reprovar {
    background: #fff;
    border: 1px solid #8e6bb8;
    color: #5a3d7a;
  }

  .btn-reprovar:hover {
    background: #f4f1f8;
    color: #4a2f6a;
  }

  .btn-reprovar-confirmar {
    background: #6f4f96;
    border: 1px solid #6f4f96;
    color: #fff;
  }

  .btn-reprovar-confirmar:hover {
    background: #5e4182;
    color: #fff;
  }

  .btn-sair {
    background: #fdf1f1;
    border: 1px solid #e4d7d7;
    color: #a13c3c;
    font-weight: 600;
  }

  .btn-sair:hover {
    background: #fbe7e7;
    border-color: #d9c2c2;
    color: #a13c3c;
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/liberar-pagamento/componentes/ModalDetalheLancamento.vue